import React, { memo } from "react";
import { StyledTooltip } from "./styles";

const Tooltip = ({
  children,
  color = "#ffffff",
  title,
  border = 2,
  maxWidth,
  mouseLeaveDelay = 0.1,
  ...rest
}) => (
  <StyledTooltip
    color={color}
    title={title}
    overlayStyle={{
      borderRadius: `${border}px`,
      maxWidth: `${maxWidth}px`,
    }}
    overlayInnerStyle={{
      borderRadius: `${border}px`,
      maxWidth: `${maxWidth}px`,
    }}
    mouseLeaveDelay={mouseLeaveDelay}
    {...rest}
  >
    {children}
  </StyledTooltip>
);

export default memo(Tooltip);
